import React from 'react';
import { string } from 'prop-types';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const ThreeDotsMoreIcon = React.forwardRef(({ height, viewBox, width, fill, ...rest }, ref) => {
    return (
        <SvgIcon
            ref={ref}
            width={width}
            height={height}
            viewBox={viewBox}
            fill="none"
            cursor="pointer"
            {...rest}
        >
            <path
                d="M12 13.5C12.5523 13.5 13 13.0523 13 12.5C13 11.9477 12.5523 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5C11 13.0523 11.4477 13.5 12 13.5Z"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 6.5C12.5523 6.5 13 6.05228 13 5.5C13 4.94772 12.5523 4.5 12 4.5C11.4477 4.5 11 4.94772 11 5.5C11 6.05228 11.4477 6.5 12 6.5Z"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 20.5C12.5523 20.5 13 20.0523 13 19.5C13 18.9477 12.5523 18.5 12 18.5C11.4477 18.5 11 18.9477 11 19.5C11 20.0523 11.4477 20.5 12 20.5Z"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
});

ThreeDotsMoreIcon.displayName = 'ThreeDotsMoreIcon';

ThreeDotsMoreIcon.propTypes = {
    height: string,
    width: string,
    viewBox: string,
    fill: string,
};

ThreeDotsMoreIcon.defaultProps = {
    height: '25',
    width: '24',
    viewBox: '0 0 24 25',
    fill: MIGRATED_COLORS.black,
};

export default ThreeDotsMoreIcon;
